<script>
import { clientApi } from '@phoenix/clientApi';

export default {
  props: {
    sizeIds: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      minWristSize: null,
      maxWristSize: null,
      small: null,
      large: null,
      sizeSelected: null,
      hasSubmitted: false,
    };
  },

  computed: {
    isSizeEmpty() {
      return !this.sizeSelected || this.sizeSelected === '';
    },

    hasSizeSelected() {
      return this.hasSubmitted && this.sizeSelected !== null;
    },

    hasSizesConfigured() {
      return this.small && this.large;
    },

    size() {
      if (!this.sizeSelected || this.isSelectedSizeOutOfBound) {
        return '';
      }

      switch (true) {
        case this.sizeSelected < this.small:
          return this.sizeIds.small;
        case this.sizeSelected > this.large:
          return this.sizeIds.large;
        default:
          return this.sizeIds.standard;
      }
    },

    isSelectedSizeOutOfBound() {
      return this.sizeSelected < this.minWristSize || this.sizeSelected > this.maxWristSize;
    },
  },

  async mounted() {
    const watchReference = new URLSearchParams(window.location.search).get('engraved-reference') ?? null;
    const {
      data: { data },
    } = await clientApi.get(window.route('api.search.strapSizesFromWatchRef'), {
      params: {
        watchReference,
      },
    });

    this.minWristSize = data.minWristSize;
    this.maxWristSize = data.maxWristSize;
    this.small = data.small;
    this.large = data.large;
  },
  methods: {
    selectSize() {
      document
        .querySelector(
          `.product-size-radio-selector input[name="strap-size-radio"][data-strap-size="${this.size}"]:not([disabled])`,
        )
        ?.click();
      window.tracking.pushEvent(window.tracking.getStrapSizeFinderSelectSizeEvent(this.sizeSelected));
      this.toggleSubmit();
    },

    toggleSubmit() {
      if (this.hasSubmitted) {
        this.sizeSelected = null;
      }
      this.hasSubmitted = !this.hasSubmitted;
    },
  },
};
</script>

<template>
  <div v-if="hasSizesConfigured" class="product-page-details__infos-size">
    <div class="h6 product-page-details__infos-size-title">{{ $t('strapSizeFinder.form.title') }}</div>

    <form v-show="!hasSizeSelected" @submit.prevent="selectSize">
      <div id="text-field" class="form-field">
        <label id="text-label" for="text" class="field-label sr-only">
          {{ $t('strapSizeFinder.form.input.label') }}
        </label>
        <input
          id="text"
          v-model="sizeSelected"
          :placeholder="$t('strapSizeFinder.form.input.placeholder')"
          :required="true"
          type="number"
          inputmode="decimal"
          class="field field--text"
        />
      </div>

      <button class="btn btn--default btn--full" :disabled="isSizeEmpty">
        <span class="btn__text">{{ $t('strapSizeFinder.form.submit') }}</span>
      </button>

      <slot name="measure-wrist-cta" />
    </form>
    <div v-show="hasSizeSelected">
      <template v-if="isSelectedSizeOutOfBound">
        <div class="product-page-details__infos-size-description">
          {{
            $t('strapSizeFinder.form.result.error', {
              size: $t(`strapSizeFinder.size.${size}`),
            })
          }}
        </div>
      </template>

      <template v-else>
        <div>
          <strong>
            {{
              $t('strapSizeFinder.form.result.title', {
                size: sizeSelected,
              })
            }}
          </strong>
        </div>
        <div class="product-page-details__infos-size-description">
          {{
            $t('strapSizeFinder.form.result.content', {
              size: $t(`strapSizeFinder.size.${size}`),
            })
          }}
        </div>
      </template>

      <button type="button" class="btn btn--default btn--link btn--underlined" @click="toggleSubmit">
        <span class="btn__text">{{ $t('strapSizeFinder.form.resubmit') }}</span>
      </button>
    </div>
  </div>
</template>
